var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramAltCircleGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #747474;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.9,9.4c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.9,5.6h-5.9c-2,0-3.5,1.6-3.5,3.5v5.9c0,1.9,1.6,3.5,3.5,3.5h5.9c1.9,0,3.5-1.6,3.5-3.5v-5.9c0-1.9-1.6-3.5-3.5-3.5ZM11.9,15.9c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8,3.8,1.7,3.8,3.8c.1,2.1-1.7,3.8-3.8,3.8ZM16.2,8.8c-.6,0-1-.4-1-1s.4-1,1-1,1,.4,1,1-.5,1-1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12,12-5.4,12-12S18.6,0,12,0ZM19.5,15c0,2.6-2.1,4.7-4.7,4.7h-5.8c-2.6,0-4.7-2.1-4.7-4.7v-5.9c0-2.6,2.1-4.7,4.7-4.7h5.9c2.6,0,4.7,2.1,4.7,4.7v5.9h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramAltCircleGris);
export default __webpack_public_path__ + "static/media/instagram-alt-circle-gris.4921c26bfd6a1d94a1b959b23ec579b8.svg";
export { ForwardRef as ReactComponent };